import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { loadIntlPolyfills } from './app/lib/utils/intl-polyfills';

// Renders whether or not the polyfills load: without them only plural copy degrades.
loadIntlPolyfills()
  .catch((error) => console.error('loadIntlPolyfills: Intl polyfills failed to load; plural copy may show raw ICU', error))
  .finally(() => { ReactDOM.render(<App />, document.getElementById('root')); });

// Change unregister() to register() below to enable offline support / faster loads
// (with some pitfalls). See https://bit.ly/CRA-PWA
serviceWorker.unregister();
